var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndonesiaFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12_19144",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 7,
    width: 32,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 7,
    width: 32,
    height: 18,
    rx: 2,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12_19144)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 7,
    width: 32,
    height: 18,
    fill: "url(#pattern0_indo)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 7C0.895431 7 0 7.89543 0 9V23C0 24.1046 0.895431 25 2 25H30C31.1046 25 32 24.1046 32 23V9C32 7.89543 31.1046 7 30 7H2ZM3 8C1.89543 8 1 8.89543 1 10V22C1 23.1046 1.89543 24 3 24H29C30.1046 24 31 23.1046 31 22V10C31 8.89543 30.1046 8 29 8H3Z",
    fill: "#171B1E",
    fillOpacity: 0.199089
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_indo",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_12_19144",
    transform: "scale(0.00416667 0.00740741)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_12_19144",
    width: 240,
    height: 135,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAPAAAACHCAIAAACnEEO8AAAAAXNSR0IArs4c6QAAAqhJREFUeAHt1rENAjEUBUGM3AAhBdDd5dfl9XIiRkZuYzXu4O2fwON6fR6eApUCz8oQOxTYBYDmIFUA6NQ5jQGagVQBoFPnNAZoBlIFgE6d0xigGUgVADp1TmOAZiBVAOjUOY0BmoFUAaBT5zQGaAZSBYBOndMYoBlIFQA6dU5jgGYgVQDo1DmNAZqBVAGgU+c0BmgGUgWATp3TGKAZSBUAOnVOY4BmIFUA6NQ5jQGagVQBoFPnNAZoBlIFgE6d0xigGUgVADp1TmOAZiBVAOjUOY0BmoFUAaBT5zQGaAZSBYBOndMYoBlIFQA6dU5jgGYgVQDo1DmNAZqBVAGgU+c0BmgGUgWATp3TGKAZSBUAOnVOY4BmIFUA6NQ5jQGagVQBoFPnNAZoBlIFgE6d0xigGUgVADp1TmOAZiBVAOjUOY0BmoFUAaBT5zQGaAZSBYBOndMYoBlIFQA6dU5j5u/+qqBApsB8n0dmjCEKjLWWCgpkCvhDZ05pyC4ANAepAkCnzmkM0AykCgCdOqcxQDOQKgB06pzGAM1AqgDQqXMaAzQDqQJAp85pDNAMpAoAnTqnMUAzkCoAdOqcxgDNQKoA0KlzGgM0A6kCQKfOaQzQDKQKAJ06pzFAM5AqAHTqnMYAzUCqANCpcxoDNAOpAkCnzmkM0AykCgCdOqcxQDOQKgB06pzGAM1AqgDQqXMaAzQDqQJAp85pDNAMpAoAnTqnMUAzkCoAdOqcxgDNQKoA0KlzGgM0A6kCQKfOaQzQDKQKAJ06pzFAM5AqAHTqnMYAzUCqANCpcxoDNAOpAkCnzmkM0AykCgCdOqcxQDOQKgB06pzGAM1AqgDQqXMaAzQDqQJAp85pDNAMpAoAnTqnMUAzkCoAdOqcxgDNQKoA0KlzGgM0A6kCf6u1CO83j3pzAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndonesiaFlag);
export default __webpack_public_path__ + "static/media/indonesia_flag.08340cd5391ac46db0a6a116fb7e161f.svg";
export { ForwardRef as ReactComponent };